import { useCreateAccount } from "@/features/accounts/hooks/useAccounts";
import { startAccountResearchJobsToast } from "@/features/campaigns/utils/enrollmentBatchToast";
import { useMainStore } from "@/stores";
import { companyDomainHref } from "@/features/dashboard/utils/accountsDashboardUtils";

/** Adds a recommended company (custom search or look-alike) as an account. */
export function useAddRecommendedAccount(account) {
  const userId = useMainStore((state) => state.user?.id);
  const href = companyDomainHref(account?.company_domain);
  const isAlreadyAdded = account?.recommendation_status === "added";
  const {
    mutate: createAccount,
    isPending: isAdding,
    isSuccess: isCreated,
  } = useCreateAccount({
    action: (data) => {
      startAccountResearchJobsToast(data.map((item) => item?.job_id));
    },
  });
  const isAdded = isAlreadyAdded || isCreated;
  const canAdd = Boolean(userId && href) && !isAdding && !isAdded;

  const add = () => {
    if (canAdd) createAccount({ userId, websiteUrls: [href] });
  };

  return { add, canAdd, isAdding, isAdded, hasDomain: Boolean(href) };
}
